module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.encerrado) ? _c('div', [(!_vm.numeroProjeto && _vm.loading.carregandoProjetos) ? _c('div', {
    staticClass: "box"
  }, [_vm._m(0)]) : (_vm.numeroProjeto || _vm.listaProjetos.length > 0 || !_vm._.isEmpty(_vm.projeto)) ? _c('div', {
    staticClass: "box",
    attrs: {
      "id": "pendencias_projeto"
    }
  }, [(!_vm.propsNumeroProjeto) ? _c('div', {
    staticClass: "box-header"
  }, [(_vm.listaProjetos.length > 1) ? _c('span', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pendencias.mandatos || _vm.loading.pendencias.relatorios || _vm.loading.pendencias.itensOrcamento),
      expression: "loading.pendencias.mandatos || loading.pendencias.relatorios || loading.pendencias.itensOrcamento"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.numeroProjetoSelecionado),
      expression: "configuracoes.numeroProjetoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projeto",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.configuracoes, "numeroProjetoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selecionaProjeto]
    }
  }, _vm._l((_vm.listaProjetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.ds_codigo_projeto_erp,
        "selected": projeto.ds_codigo_projeto_erp === _vm.configuracoes.numeroProjetoSelecionado
      }
    }, [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp) + " - " + _vm._s(projeto.ds_nome))])
  }), 0)])])])]) : (_vm.listaProjetos.length === 1) ? _c('span', [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.listaProjetos[0].ds_codigo_projeto_erp) + " - " + _vm._s(_vm.listaProjetos[0].ds_nome))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto)) ? _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "pendencias"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pendencias.mandatos),
      expression: "loading.pendencias.mandatos"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Mandatos\n                "), (this.$root.authorize('minha-entidade-visualizar')) ? _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-external-link",
    attrs: {
      "title": '<h5>Vai para a tela do Cadastro da Entidade</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cadastro-entidade-edita',
          params: {
            id: _vm.usuarioLogado.entidade.id
          }
        })
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('table', {
    staticClass: "table table-condensed b0"
  }, [(_vm._.find(_vm.pendencias.mandatos, function(m) {
    return _vm.situacaoPendencia(m.fim_mandato) > -30
  })) ? _c('tbody', _vm._l((_vm.pendencias.mandatos), function(mandato) {
    return (_vm.situacaoPendencia(mandato.fim_mandato) > -30) ? _c('tr', [_c('td', {
      staticClass: "esmaecido w20"
    }, [_vm._v(_vm._s(mandato.cargo))]), _vm._v(" "), _c('td', {
      staticClass: "w30"
    }, [_vm._v(_vm._s(mandato.nome))]), _vm._v(" "), _c('td', {
      staticClass: "realce w20"
    }, [_c('strong', [_vm._v("Término em " + _vm._s(_vm._f("moment")(mandato.fim_mandato, "L")))])]), _vm._v(" "), _c('td', [(_vm.situacaoPendencia(mandato.fim_mandato) > 0) ? _c('span', {
      staticClass: "vencido"
    }, [_vm._v("Vencido")]) : (_vm.situacaoPendencia(mandato.fim_mandato) === 0) ? _c('span', {
      staticClass: "vence_hoje"
    }, [_vm._v("Vence Hoje")]) : (_vm.situacaoPendencia(mandato.fim_mandato) > -30) ? _c('span', {
      staticClass: "vence_breve"
    }, [_vm._v("Vence em até 30 dias")]) : _vm._e()])]) : _vm._e()
  }), 0) : _c('tbody', [_vm._m(1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pendencias.relatorios),
      expression: "loading.pendencias.relatorios"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatórios de Execução\n                "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-external-link",
    attrs: {
      "title": '<h5>Vai para a tela do cronograma dos Relatórios de Execução</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'visualiza-relatorio-execucao',
          params: {
            id: _vm.projeto.id_projeto
          }
        })
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-10 col-sm-12"
  }, [_c('table', {
    staticClass: "table table-condensed b0"
  }, [_c('tbody', [(_vm.pendencias.relatorios.length > 0) ? [_vm._l((_vm.relatorioDisponivel()), function(relatorio) {
    return [(_vm._.isNull(relatorio)) ? _c('tr', [_c('td', [_vm._v("Não há relatórios pendentes nem futuros para apresentar")])]) : _c('tr', [_c('td', {
      staticClass: "esmaecido"
    }, [_vm._v(_vm._s(relatorio.tipo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "110px"
      }
    }, [_vm._v("Relatório nº " + _vm._s(relatorio.sequencia))]), _vm._v(" "), _c('td', {
      staticClass: "realce"
    }, [_c('strong', [_vm._v(_vm._s(relatorio.situacao))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "285px"
      }
    }, [(_vm._.includes(['Não apresentado'], relatorio.situacao.substr(0, 15))) ? _c('span', {
      staticClass: "vencido"
    }, [_vm._v("Limite para apresentação até " + _vm._s(_vm._f("moment")(relatorio.termino_concluir, "L")))]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Pendente de pre'], relatorio.situacao.substr(0, 15))) ? _c('span', {
      staticClass: "vence_breve"
    }, [_vm._v("Prazo regular para apresentação até " + _vm._s(_vm._f("moment")(relatorio.depois_30_final_ciclo, "L")))]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Devolvido para '], relatorio.situacao.substr(0, 15))) ? _c('span', {
      staticClass: "vence_hoje"
    }, [_vm._v("Rever o relatório")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Em análise pela'], relatorio.situacao.substr(0, 15))) ? _c('span', {}) : _vm._e(), _vm._v(" "), (_vm._.includes(['Fora do período'], relatorio.situacao.substr(0, 15)) && _vm._.has(relatorio, 'antes_30_final_ciclo')) ? _c('span', {
      staticClass: "vence_breve"
    }, [_vm._v("Ficará disponível a partir de " + _vm._s(_vm._f("moment")(relatorio.antes_30_final_ciclo, "L")))]) : _vm._e()])])]
  })] : [_vm._m(2)]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pendencias.revisoes),
      expression: "loading.pendencias.revisoes"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Tarefas para Revisão\n                "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "fa fa-external-link",
    attrs: {
      "title": '<h5>Vai para a tela de Solicitações onde pode listar e visualizar as tarefas</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'solicitacao-lista'
        })
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-10 col-sm-12"
  }, [_c('table', {
    staticClass: "table table-condensed b0"
  }, [_c('tbody', [(_vm.pendencias.tarefasRevisao.length > 0) ? [_vm._l((_vm.pendencias.tarefasRevisao), function(tarefa) {
    return [_c('tr', [_c('td', {
      staticClass: "esmaecido"
    }, [_vm._v("\n                          " + _vm._s(tarefa.id) + "\n                          "), (_vm._.includes(['ALTERACOES_PROJETO'], tarefa.nome)) ? _c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large'
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
      }],
      staticClass: "fa fa-external-link",
      attrs: {
        "title": '<h5>Vai direto para a solicitação ID ' + tarefa.id + '</h5>'
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'solicitacao-alteracoes-projeto',
            params: {
              id: tarefa.id
            }
          })
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(tarefa.processoTexto))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "esmaecido"
    }, [_vm._v("Criado em ")]), _vm._v(" " + _vm._s(_vm._f("moment")(tarefa.inicioProcesso, "L")))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "esmaecido"
    }, [_vm._v("Revisão desde ")]), _vm._v(" " + _vm._s(_vm._f("moment")(tarefa.inicioTarefa, "DD/MM/YYYY  HH:mm")))]), _vm._v(" "), _c('td', [(!_vm._.isNull(tarefa.valor)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))]) : _c('span', [_vm._v(" ")])])])]
  })] : [_vm._m(3)]], 2)])])])]), _vm._v(" "), (_vm.loading.pendencias.avaliacoes || _vm.pendencias.avaliacoes.length > 0) ? _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pendencias.avaliacoes),
      expression: "loading.pendencias.avaliacoes"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-10 col-sm-12"
  }, [_c('table', {
    staticClass: "table table-condensed b0"
  }, [_c('tbody', [_vm._l((_vm.avaliacaoDisponivel()), function(avaliacao) {
    return [_c('tr', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'preenche-formulario',
            params: {
              id: avaliacao.acesso
            }
          })
        }
      }
    }, [_c('td', [_c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-external-link",
      attrs: {
        "title": '<h5>Abre o formulário de Avaliação deste Projeto</h5>'
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "esmaecido",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(avaliacao.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(avaliacao.nome))]), _vm._v(" "), _c('td', {
      staticClass: "realce"
    }, [_c('strong', [_vm._v(_vm._s(avaliacao.situacao))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'preenche-formulario',
            params: {
              id: avaliacao.acesso
            }
          })
        }
      }
    }, [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "225px"
      },
      attrs: {
        "colspan": "3"
      }
    }, [(_vm._.includes(['SOLICITACAO', 'REVISAO'], avaliacao.tarefaAtual)) ? _c('span', {
      class: avaliacao.info.classe
    }, [_vm._v(_vm._s(avaliacao.info.texto))]) : _vm._e()])])]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pendencias.itensOrcamento),
      expression: "loading.pendencias.itensOrcamento"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body cronogramaff"
  }, [(_vm._.find(_vm.pendencias.itensOrcamento, function(i) {
    return ('' + i.economicidade) === '0' && _vm.percentual(i.liberado, i.orcado) < 100
  }) && !_vm._.includes(['ENC', 'ESE'], _vm.projeto.situacao)) ? _c('div', {
    staticClass: "col-lg-9 col-md-11 col-sm-12"
  }, [_vm._l((_vm._.groupBy(_vm.pendencias.itensOrcamento, 'origem')), function(itensAtividades, origem) {
    return [(_vm._.find(itensAtividades, function(i) {
      return ('' + i.economicidade) === '0' && _vm.percentual(i.liberado, i.orcado) < 100
    })) ? _c('table', {
      staticClass: "table table-condensed b0"
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(origem))]), _vm._v(" "), _c('td', {
      staticClass: "esmaecido"
    }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
      staticClass: "esmaecido"
    }, [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm._.groupBy(itensAtividades, 'id_atividade')), function(itens, atividadeId) {
      return [(_vm._.find(itens, function(i) {
        return ('' + i.economicidade) === '0' && _vm.percentual(i.liberado, i.orcado) < 100
      })) ? _c('tr', {
        staticClass: "atividade",
        attrs: {
          "id": 'atividadeId' + atividadeId
        },
        on: {
          "click": function($event) {
            return _vm.mostraAtividade(itens)
          }
        }
      }, [_c('td', {
        staticClass: "esquerda celula b1 b3 b4 nome_atividade"
      }, [_c('i', {
        class: 'fa fa-caret-' + (itens[0]['mostrar'] ? 'up' : 'down'),
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("  " + _vm._s(itens[0].descricao_atividade))]), _vm._v(" "), _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
        }],
        staticClass: "centralizado celula b1 b3 b4 w10",
        attrs: {
          "title": '<h5>Início da atividade</h5>'
        }
      }, [_vm._v(_vm._s(_vm.periodoParaMesAno(itens[0].inicio_atividade, _vm.projeto.inicio, 'MMMM/YYYY')))]), _vm._v(" "), _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
        }],
        staticClass: "centralizado celula b1 b3 b4 w10",
        attrs: {
          "title": '<h5>Término da atividade</h5>'
        }
      }, [_vm._v(_vm._s(_vm.periodoParaMesAno(itens[0].termino_atividade, _vm.projeto.inicio, 'MMMM/YYYY')))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b2",
        staticStyle: {
          "font-weight": "normal",
          "width": "260px"
        }
      }, [(_vm.dataParaPeriodo(_vm.hoje, _vm.projeto.inicio) > itens[0].termino_atividade) ? _c('span', {
        staticClass: "vencido"
      }, [_vm._v("\n                            Atividade não concluída no prazo\n                          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._l((itens), function(item) {
        return (('' + item.economicidade) === '0' && _vm.percentual(item.liberado, item.orcado) < 100 && item.mostrar) ? [_c('tr', {
          attrs: {
            "id": 'itemId_' + item.id
          }
        }, [_c('td', {
          staticClass: "celula b3 b4"
        }, [_c('div', {
          staticClass: "item"
        }, [_c('div', {
          staticClass: "text-bold esquerda"
        }, [_vm._v(_vm._s(item.item))]), _vm._v(" "), _c('div', {
          staticClass: "observacao esquerda"
        }, [_c('span', {
          staticClass: "id_item"
        }, [_vm._v("#" + _vm._s(item.id))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.observacao))])])])]), _vm._v(" "), _c('td', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado celula b3",
          attrs: {
            "title": '<h5>Valor orçado</h5>'
          }
        }, [_vm._v(_vm._s(_vm._f("decimal2")(item.orcado)))]), _vm._v(" "), _c('td', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado celula b3",
          attrs: {
            "title": '<h5>Valor liberado</h5>'
          }
        }, [_vm._v(_vm._s(_vm._f("decimal2")(item.liberado)))]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b2"
        }, [_c('span', {
          staticClass: "realce"
        }, [_vm._v(_vm._s(('' + item.economicidade) === '1' ? 100 : _vm.percentual(item.liberado, item.orcado)) + "%")])])])] : _vm._e()
      })]
    })], 2)]) : _vm._e()]
  })], 2) : _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("Não há itens de orçamento pendentes para liberar" + _vm._s(_vm._.includes(['ENC', 'ESE'], _vm.projeto.situacao) ? '. Projeto encerrado' : ''))])])])])])]) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Verificando pendências em projeto(s) ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Não há mandatos vencidos ou a vencer nos próximos 30 dias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Não foram enontrados relatórios de execução")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Não foram enontradas tarefas para que faça a revisão da solicitação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Avaliação de Projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Itens do Orçamento não executados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f1bf7c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/PendenciasProjeto.vue
// module id = 1965
// module chunks = 2